{
  "blocks": [
    {
      "id": "program-full-assessment",
      "kind": "program",
      "tags": [
        "assessment",
        "both-partners",
        "testing",
        "genetic-screening",
        "genomic",
        "metabolic",
        "nutritional",
        "autoimmune",
        "pharmacogenomics"
      ],
      "title": "Full Fertility & Genomic Assessment",
      "subtitle": "The most comprehensive fertility workup possible: hormones, metabolics, genetics, and genomics in one program",
      "icon": "🔎",
      "body": {
        "duration": "6–12 weeks",
        "includes": [
          "Fertility baseline: AMH, FSH, LH, estradiol, ultrasound with AFC for her; semen analysis for him",
          "Comprehensive biomarker panel: 100+ markers across hormones, thyroid, metabolic health, advanced lipids, inflammation, nutrients, liver, kidney, CBC, autoimmune markers, infectious disease, and more",
          "Fertility-specific add-ons the health panel misses: antiphospholipid antibodies, coagulation genetics (Factor V Leiden, MTHFR), mid-luteal progesterone, infectious disease screening",
          "Expanded carrier panel (200+ conditions) for both partners",
          "Whole exome or whole genome sequencing for both partners",
          "Pharmacogenomic profiling: how you metabolize fertility medications (letrozole, gonadotropins, progesterone)",
          "Polygenic risk scores for PMOS (ex PCOS), endometriosis, POI, recurrent loss",
          "Genetic counselor deep-dive session for complex genomic findings",
          "Complete synthesis: 60-minute session connecting every result into a single actionable plan"
        ],
        "priceRange": {
          "low": 3000,
          "high": 8000
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "both",
        "category": "assessment",
        "moduleIds": [
          "module-female-hormone-baseline",
          "module-male-fertility-baseline",
          "module-comprehensive-wellness",
          "module-genetic-carrier",
          "module-comprehensive-genomic"
        ],
        "phases": [
          {
            "title": "Fertility Baseline",
            "description": "Standard fertility testing for both partners in parallel",
            "moduleIds": [
              "module-female-hormone-baseline",
              "module-male-fertility-baseline"
            ],
            "parallel": true
          },
          {
            "title": "Comprehensive Health Panel",
            "description": "100+ biomarkers via partner lab: metabolic, hormonal, inflammatory, autoimmune, nutritional, liver, kidney, and more",
            "moduleIds": ["module-comprehensive-wellness"]
          },
          {
            "title": "Genetic & Genomic",
            "description": "Carrier screening plus whole exome/genome sequencing with pharmacogenomics",
            "moduleIds": [
              "module-genetic-carrier",
              "module-comprehensive-genomic"
            ],
            "parallel": true
          }
        ],
        "steps": [
          {
            "title": "Fertility baseline",
            "description": "AMH + hormone panel + ultrasound for her (cycle day 2–3), semen analysis for him. Results in 1–2 weeks."
          },
          {
            "title": "Comprehensive health panel",
            "description": "Single fasting morning draw for 100+ biomarkers via our lab partner: metabolic, hormonal, inflammatory, nutritional, autoimmune, liver, kidney, CBC, and pregnancy-readiness markers. Timed add-ons include mid-luteal progesterone when confirming ovulation."
          },
          {
            "title": "Genetic & genomic samples",
            "description": "Blood or saliva for carrier screening (200+ conditions) and whole exome/genome sequencing for both partners."
          },
          {
            "title": "Results arrive in waves",
            "description": "Fertility baseline: 1–2 weeks. Health panel: 1–2 weeks. Carrier screening: 2–4 weeks. Genomic profiling: 6–12 weeks."
          },
          {
            "title": "Complete synthesis",
            "description": "60-minute session connecting every result, from your insulin levels to your pharmacogenomic profile, into one actionable reproductive plan."
          }
        ]
      },
      "sources": [
        {
          "title": "Diagnostic evaluation of the infertile female: a committee opinion",
          "journal": "Fertility and Sterility",
          "year": 2021,
          "evidenceLevel": "expert-opinion"
        },
        {
          "title": "Clinical utility of pharmacogenomic testing in reproductive medicine",
          "journal": "Fertility and Sterility",
          "year": 2023,
          "evidenceLevel": "observational"
        },
        {
          "title": "Vitamin D and IVF outcomes: a systematic review and meta-analysis",
          "journal": "Human Reproduction",
          "year": 2022,
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-full-assessment",
      "to": "module-female-hormone-baseline",
      "type": "contains"
    },
    {
      "from": "program-full-assessment",
      "to": "module-male-fertility-baseline",
      "type": "contains"
    },
    {
      "from": "program-full-assessment",
      "to": "module-comprehensive-wellness",
      "type": "contains"
    },
    {
      "from": "program-full-assessment",
      "to": "module-genetic-carrier",
      "type": "contains"
    },
    {
      "from": "program-full-assessment",
      "to": "module-comprehensive-genomic",
      "type": "contains"
    },
    {
      "from": "program-full-assessment",
      "to": "test-comprehensive-biomarker-panel",
      "type": "related-to",
      "label": "Comprehensive biomarker panel"
    },
    {
      "from": "program-full-assessment",
      "to": "test-whole-genome",
      "type": "related-to",
      "label": "Whole genome sequencing"
    }
  ],
  "localeVariants": []
}
